import { render, staticRenderFns } from "./DiscountCodeInput.vue?vue&type=template&id=b6e9f240&scoped=true"
import script from "./DiscountCodeInput.vue?vue&type=script&lang=js"
export * from "./DiscountCodeInput.vue?vue&type=script&lang=js"
import style0 from "./DiscountCodeInput.vue?vue&type=style&index=0&id=b6e9f240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e9f240",
  null
  
)

export default component.exports